import React from 'react';
import { createUseStyles } from 'react-jss';
import { NavLink } from 'react-router-dom';

const useStyles = createUseStyles({
  navlink__tab: {
    textDecoration: 'none',
    fontWeight: '500',
    fontFamily: '"SF UI Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    color: 'rgb(66, 90, 112)',
    padding: '.5em 1em .5em 1em',
    borderRadius: '.5em',
    transition: 'all 0.1s linear',
    '&:hover': {
      backgroundColor: 'rgba(67, 90, 111, 0.06)',
    },
  },
  'navlink__tab-active': {
    color: 'rgb(16, 112, 202)',
    backgroundColor: 'rgba(16, 112, 202, 0.09) !important',
  },
});

export const NavLinkTab = React.memo(({
  to,
  children,
  className,
}: {
  to: string,
  children: React.ReactNode | string,
  className?: string,
}) => {
  const classes = useStyles();

  return (
    <NavLink
      to={to}
      className={`${classes.navlink__tab} ${className}`}
      activeClassName={classes['navlink__tab-active']}
    >
      {children}
    </NavLink>
  );
});

NavLinkTab.displayName = 'NavLinkTab';
